// extracted by mini-css-extract-plugin
module.exports = {"ContactData":"ContactData_ContactData__1YKL8"};